import { isPlatformBrowser } from '@angular/common';
import {
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    inject,
} from '@angular/core';

/** Fade + slide in once when scrolled into view (like framer-motion `whileInView` + `once`). */
@Directive({
    selector: '[reveal]',
    standalone: true,
    host: {
        class: 'reveal',
        '[style.--reveal-x]': 'revealX + "px"',
        '[style.--reveal-y]': 'revealY + "px"',
        '[style.--reveal-delay]': 'revealDelay + "s"',
    },
})
export class RevealDirective implements OnInit, OnDestroy {
    @Input() revealX = 0;
    @Input() revealY = 20;
    @Input() revealDelay = 0;
    /** fraction of the element that must be visible, like framer-motion `amount` */
    @Input() revealAmount = 0;

    private readonly el = inject(ElementRef<HTMLElement>);
    private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    private observer?: IntersectionObserver;

    ngOnInit(): void {
        if (!this.isBrowser) return;
        this.observer = new IntersectionObserver(
            (entries) => {
                if (!entries.some((e) => e.isIntersecting)) return;
                this.el.nativeElement.classList.add('revealed');
                this.observer?.disconnect();
            },
            { threshold: this.revealAmount },
        );
        this.observer.observe(this.el.nativeElement);
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
